import LoginEmailContent from '../Email';
import LoginPasswordContent from '../Password';

export default function AuthModalContentLoginStepsForm() {
  return (
    <>
      <LoginEmailContent />
      <LoginPasswordContent />
    </>
  );
}
